<template>
  <div>
    <a-select
      showSearch
      placeholder=""
      optionFilterProp="children"
      style="width: 100%"
      :allowClear="true"
      :defaultValue="record && record.status ? record.status : null"
      @change="selectStatusVal"
    >
      <a-select-option
        v-for="(val, key, index) in orderStatus"
        :key="index"
        :value="key"
      >
        {{val}}
      </a-select-option>
    </a-select>
  </div>
</template>

<script>
export default {
  data () {
    return {
      orderStatus: {
        toBeShipped: '待发货',
        pendingReceipt: '待收货',
        toBeEvaluated: '待评价',
        returnExchange: '退换货',
        completed: '已完成'
      }
    }
  },
  syncProps: ['value', '_value'],
  props: {
    record: Object,
    value: null,
    model: Object,
    field: Object // 当前field对象
  },
  methods: {
    selectStatusVal (val) {
      this._value = val
    }
  }
}
</script>

<style>

</style>
